import { render } from "./ProducerRateTable.vue?vue&type=template&id=e79bea96&scoped=true"
import script from "./ProducerRateTable.vue?vue&type=script&lang=js"
export * from "./ProducerRateTable.vue?vue&type=script&lang=js"

import "./ProducerRateTable.vue?vue&type=style&index=0&id=e79bea96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79bea96"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
